export enum FleetDisturbanceAnalysisType {
  RMS = 1,
  SARFI = 2,
}
